import { ManageCapacitySeeResultPage } from "../../../web/pages/ManageCapacity/ManageCapacitySeeResults";
import React, { useEffect, useState } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getNetworkStatus, getUserMasterData } from "../../../selectors/selector";
import { showNetworkAlert, showAlert } from "../../../actions/App/action";
import {
  getCapacityToSeeResult,
  selectCapacityLoadCapacity,
  selectCapacityLoadLoadPostings,
  selectCapacityLoadCapacityLoadCount,
} from "../../../selectors/Manage/selector";
import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from "../../../utils/injectReducer";
import reducer from "../../../reducers/manage/reducer";
import saga from "../../../saga/Manage/saga";
import { useLocation } from "react-router";
import { compose } from "redux";
import { getCapacityLoads, removeManageCapacityLoadsResults } from "../../../actions/manage/action";
import {
  buyLoadRequest,
  buyLoadShipmentRequest,
  buyLoadStatusRemove,
} from "../../../actions/BookLoad/action";
import { WatchedLoadModel } from "../../../models/home/WatchedLoads.model";
import { fetchShipments } from "../../../actions/carrierAssign/action";
import {
  addWatchLoad,
  clearApiResponseError,
  removeWatchLoad,
  removeWatchLoadSuccess,
  setWatchedLoadFilter,
  watchedLoadsRequest,
  removeRecommendedResults,
} from "../../../actions/Home/action";
import { removeSearchResults } from "../../../actions/Search/action";
import { toggleWatchLoad } from "../../../web/utils/watchedUtil";
import {
  getApiErrorMessage,
  getTotalWatchedRecords,
  getWatchedFilter,
  makeSelectWatchedLoaded,
  makeSelectWatched,
} from "../../../selectors/Home/selector";
import { getBookLoadStatus } from "../../../selectors/Myload/selector";
import homeSaga from "../../../saga/Home/saga";
import { pickUpStartDate, SORTING_ORDER_ASC, CAPACITY_LOADS_PAGESIZE, SORTING_ORDER_DESC } from "../../../utils/constants";
import { getFormatRoles } from "../../../utils/formatData";
import { CapacityModel } from "../../../models/manage/capacity.model";

const ManageCapacitySeeResultContainer: React.FunctionComponent<any> = (
  props: any
) => {
  const location = useLocation();
  const locationState: any =
    (location?.state) ?? {};

  const {
    userDetails,
    watchedLoads,
    capacityToSeeResult,
    getCapacityLoads,
    capacityLoadCapacity,
    capacityLoadLoadPostings,
  } = props;
  const [shouldShowLoadMoreUpdate,setShouldShowLoadMoreUpdate]= useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [sortColumn, setSortColumn] = useState<string>(pickUpStartDate);
  const [sortDirection, setSortDirection] = useState<string>(SORTING_ORDER_ASC);
  const { data: { capacityId, loadCount: capacityLoadCount } = { capacityId: "", loadCount: 0 } } = capacityToSeeResult;
  const totalRecords = capacityLoadCount;

  const roles = getFormatRoles();

  const getCapacityLoadsData = (page: number, sortColumn: string, sortDirection: string, showLoader:boolean) => {
    const capacityModel = new CapacityModel();
    const query = capacityModel.getCapacityLoad(
      capacityId,
      (userDetails?.memberDetailsResponse?.member?.upn) || "",
      sortColumn,
      sortDirection,
      page,
      CAPACITY_LOADS_PAGESIZE
    );
    const isPagination = page > 0;
    const callback =()=>{
      setShouldShowLoadMoreUpdate((prevValue:boolean)=>!prevValue);
    } 
    getCapacityLoads({ query, isPagination,showLoader,callback });
  }

  const getWatchedLoads = (
    refreshStatus = false,
    page = 0,
    callback: any = false,
    sortColumn = "load_id",
    sortDirection: string = SORTING_ORDER_ASC,
    isPullToRefresh:boolean = false
  ) => {
    if (
      userDetails.memberDetailsResponse.member.carrierId &&
      userDetails.memberDetailsResponse.member.carrierId !== null &&
      userDetails.memberDetailsResponse.member.carrierId !== ""
    ) {
      const _WatchedLoadModel: WatchedLoadModel = new WatchedLoadModel();
      _WatchedLoadModel.carrierId = userDetails?.memberDetailsResponse?.member?.carrierId;
      _WatchedLoadModel.page = page;
      _WatchedLoadModel.userId =
        (userDetails?.memberDetailsResponse?.member?.upn) || "";
      _WatchedLoadModel.size = CAPACITY_LOADS_PAGESIZE;
      _WatchedLoadModel.sortDirection = sortDirection;
      _WatchedLoadModel.sortColumn = sortColumn;
      _WatchedLoadModel.userRole = roles.join(",") || "";
      _WatchedLoadModel.managedEquipmentCapability =
      userDetails?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability;
      _WatchedLoadModel.nonManagedEquipmentCapability =
      userDetails?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability;

      return props.watchedData({
        query: _WatchedLoadModel.getRequestPayload(),
        refreshStatus,
        callback,
        isPullToRefresh
      });
    }
  };

  const userStr: string = JSON.stringify(userDetails);

  useEffect(() => {
    if (userStr && userDetails) {
      getWatchedLoads();
    }
  }, [userStr]);

  useEffect(() => {
    if (currentPage > 0) getCapacityLoadsData(currentPage, sortColumn, sortDirection, true);
  }, [currentPage]);

  const onSortedDataHandler = (sortCol: string = sortColumn, isAsc: boolean = true) => {
    const sortDir = isAsc === true ? SORTING_ORDER_ASC : SORTING_ORDER_DESC;
    setCurrentPage(0);
    setSortColumn(sortCol);
    setSortDirection(sortDir);
    getCapacityLoadsData(0, sortCol, sortDir,true);
  };

  const onShowMoreHandler = (event: Event) => {
    event.stopPropagation();
    const totalPages: number =
      parseInt(`${totalRecords / CAPACITY_LOADS_PAGESIZE}`, 10) +
      (totalRecords % CAPACITY_LOADS_PAGESIZE > 0 ? 1 : 0);
    if (totalRecords > CAPACITY_LOADS_PAGESIZE && currentPage < totalPages - 1) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  }
  return (
    <ManageCapacitySeeResultPage
      {...props}
      module={props.location.pathname}
      capacityType={locationState.capacityType}
      data={locationState.data}
      handleClick={locationState.handleClick}
      handleDelete={locationState.handleDelete}
      handleViewClick={locationState.handleViewClick}
      hideSeeResult={locationState.hideSeeResult}
      toggleWatchLoad={toggleWatchLoad(props)}
      watchedLoads={watchedLoads}
      capacityLoadCapacity={capacityLoadCapacity}
      totalRecords={totalRecords}
      capacityLoadLoadPostings={capacityLoadLoadPostings}
      onShowMore={onShowMoreHandler}
      onSortedData={onSortedDataHandler}
      currentPage={currentPage}
      pageSize={CAPACITY_LOADS_PAGESIZE}
      shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
    />
  );
};

const key = "manage";
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });
const withHomeSaga = useInjectSaga({ key: "carrier", saga: homeSaga });

const mapStateToProps = createStructuredSelector({
  isNetWorkAvailable: getNetworkStatus(),
  isNetworkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  capacityToSeeResult: getCapacityToSeeResult(),
  capacityLoadCapacity: selectCapacityLoadCapacity(),
  capacityLoadLoadPostings: selectCapacityLoadLoadPostings(),
  capacityLoadCapacityLoadCount: selectCapacityLoadCapacityLoadCount(),
  filter: getWatchedFilter(),
  apiError: getApiErrorMessage(),
  isWatchedLoaded: makeSelectWatchedLoaded(),
  totalWatchedRecords: getTotalWatchedRecords(),
  bookLoadStatus: getBookLoadStatus(),
  watchedLoads: makeSelectWatched(),
});

const mapDispatchToProps = (dispatch: Function) => ({
  watchedData: (data: any) => dispatch(watchedLoadsRequest(data)),
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  fetchShipments: (details: any, callBack: any) =>
    dispatch(fetchShipments(details, false, callBack)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  addWatchLoad: (payload: any) => dispatch(addWatchLoad(payload)),
  removeWatchLoad: (payload: any) => dispatch(removeWatchLoad(payload)),
  setWatchedFilter: (payload: any) => dispatch(setWatchedLoadFilter(payload)),
  clearApiResponseError: () => dispatch(clearApiResponseError()),
  buyLoadRequest: (payload: any) => dispatch(buyLoadRequest(payload)),
  buyLoadStatusRemove: () => dispatch(buyLoadStatusRemove()),
  buyLoadShipmentRequest: (payload: any, renderCallback: Function) =>
    dispatch(buyLoadShipmentRequest(payload, renderCallback)),
  removeSearchResults: (data: any) => dispatch(removeSearchResults(data)),
  removewatchedResults: (payload: any) =>
    dispatch(removeWatchLoadSuccess(payload)),
  getCapacityLoads: (payload: any) => dispatch(getCapacityLoads(payload)),
  removeRecommendedResults: (data: any) =>
    dispatch(removeRecommendedResults(data)),
  removeManageCapacityLoadsResults: (data: any) =>
    dispatch(removeManageCapacityLoadsResults(data)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withSaga,
  withHomeSaga,
  withReducer,
  withConnect
)(ManageCapacitySeeResultContainer);
